import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import es from "./es.json";
import en from "./en.json";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: { es: { translation: es }, en: { translation: en } },
    fallbackLng: "es",
    supportedLngs: ["es", "en"],
    interpolation: { escapeValue: false },
    detection: {
      order: ["localStorage", "navigator"],
      caches: ["localStorage"],
      lookupLocalStorage: "pk2_lang",
    },
  });

// Sync <html lang> attribute
const setHtmlLang = () => {
  if (typeof document !== "undefined") document.documentElement.lang = i18n.language;
};
setHtmlLang();
i18n.on("languageChanged", setHtmlLang);

export default i18n;
